const $reviewSlider = $(".test_reviews [data-slider-review]");
if( $reviewSlider.length > 0 ) {
    $reviewSlider.flickity();
}
const $suggestedItem = $("[data-suggest-slider]");
if( $suggestedItem.length > 0 ) {
    $suggestedItem.flickity({
        cellAlign: 'left',
        pageDots: false,
        contain: true,
        wrapAround: true,
        imagesLoaded: true,
        groupCells: 2,
        initialIndex: 0
    });
}
if($(".product").length > 0) {

    $(".tabination ul li").click(function(e) {
        e.preventDefault();
        // active deactivate tab buttons
        $(".tabination ul li").removeClass('active');
        $(this).addClass('active');

        // show hide tab content
        var tabName = $(this).find("a").attr('data-tabName');
        $(".tabContent .tabitems").removeClass('active');
        $(".tabContent #"+tabName).addClass('active');

    });
}
// $(window).resize(function(){
    if ($(window).width() < 669) {
        let footerMenu = $('.footer__content .footer__block .footer__heading')
        footerMenu.on('click',function(){
            $(this).closest(".footer__block").siblings(".footer__block").find(".open ul").slideUp();
            $(this).closest(".footer__block").siblings(".footer__block").find(".open").removeClass("open");
            if($(this).siblings('ul').css('display')=='none'){
                $(this).parent().addClass('open')
                $(this).siblings('ul').slideDown()
            }else{
                $(this).siblings('ul').slideUp(()=>{
                    $(this).parent().removeClass('open')
                })
            }
        });
    }
// });